import { Link as LinkClipf } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MenuSubItemProps } from '../../interfaces/props/MenuSubItemProps';
import './styles.css';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { getMensagemRestricao } from '../../services/Home/HomeService';
import LoadingApp from '../LoadingApp';
import ModalFeedBack from '../ModalFeedBack';

function MenuSubItem(props: MenuSubItemProps) {

  const { to, children, cliPfPage, restricted, external, component } = props;
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('');

  const { fontSizeStyleAccessibility } = useAccessibility();

  useEffect(() => {
    isOpen(location, to);
  }, [location, to, cliPfPage]);

  const isOpen = (location: any, to: string) => {
    //Lógica para não perder o foco do menu em sub rotas
    let path = location.pathname;
    let posicaoTerceiraBarra = path.indexOf('/', (path.indexOf('/', path.indexOf('/') + 1)) + 1);
    let substringPath = path.substring(0, posicaoTerceiraBarra);
    path = substringPath === '' ? path : substringPath;

    if (path === to) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  const handleRestrictedAccess = () => {
    setLoading(true);
    getMensagemRestricao(component)
      .then(response => {
        setModalText(response.data)
      })
      .catch(error => {
        console.log(error);
        setModalText('Acesso não permitido.')
      })
      .finally(() => {
        setLoading(false);
        setShowModal(true);
      })
  }
  
  const handleAccess = () => {
    if (!restricted) {
      navigate(to);
      props.handleMenu();
    } else {
      handleRestrictedAccess();
    }
  }
  

  if (external && !restricted) {
    return (
      <li>
        <LinkClipf tabIndex={-1} underline='none' className='text-decoration-none' onClick={() => window.open(to, '_blank')}>
          <button className={`sub-item ${open ? 'open' : 'closed'}`}>
            <span className={open ? 'bold' : 'normal'} style={fontSizeStyleAccessibility}>{children}</span>
          </button>
        </LinkClipf>
      </li>
    );
  }

  return (
    <li>
      <button 
        tabIndex={0} 
        className={`sub-item ${open ? 'open' : 'closed'}`} 
        onClick={handleAccess}
      >
        <span className={open ? 'bold' : 'normal'} style={fontSizeStyleAccessibility}>{children}</span>
      </button>
      <LoadingApp showLoading={loading} />

			<ModalFeedBack
				showModal={showModal} 
				handleShowModal={() => setShowModal(false)}
				icon={'warning'}
				textButton={''} 
				title={'Acesso não permitido'}
				subTitle={modalText}
			/>
    </li>
  );

}

export default MenuSubItem;